import { render, staticRenderFns } from "./FormPlayer.vue?vue&type=template&id=2bb1a2ce&"
import script from "./FormPlayer.vue?vue&type=script&lang=js&"
export * from "./FormPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FormPlayer.vue?vue&type=style&index=0&id=2bb1a2ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports